import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6d56a12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "width-control" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "width-control" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "dialog-footer" }

import { ref, onMounted, inject } from "vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import VueJsonView from "@matpool/vue-json-view";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailLog',
  setup(__props) {

const data = ref(<any>[]);
const isLoading = ref(false);
const show = ref(false);
const dialogData = ref(<any>[]);

const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const criteria = ref({
  page: 1,
  pageSize: 20,
  accountId: accountDetails?.value.id,
  sortFeild: "createdOn",
  sortFlag: true,
});
const showData = (data: any) => {
  show.value = true;
  dialogData.value = data;
};
const reset = () => {
  criteria.value = {
    page: 1,
    pageSize: 20,
    accountId: accountDetails?.value.id,
    sortFeild: "createdOn",
    sortFlag: true,
  };
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountService.queryAccountLog(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.action,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.action) = $event)),
            class: "me-3",
            placeholder: _ctx.$t('action.action')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (reset()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.beforeEdit")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.afterEdit")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.action), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_el_tag, { type: "danger" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.before), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (
                    item.before.length >= 60 || typeof item.before === 'object'
                  )
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "small",
                                class: "ms-2",
                                onClick: ($event: any) => (showData(item.before))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("tip.viewMore")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_tag, { type: "success" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.after), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (
                    item.after.length >= 60 || typeof item.after === 'object'
                  )
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "small",
                                class: "ms-2",
                                onClick: ($event: any) => (showData(item.after))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("tip.viewMore")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
      width: "600",
      "align-center": "",
      style: {"max-height":"95vh","overflow":"auto"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (show.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (typeof dialogData.value != 'object')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(dialogData.value), 1))
          : (_openBlock(), _createBlock(_unref(VueJsonView), {
              key: 1,
              src: dialogData.value,
              theme: "rjv-default"
            }, null, 8, ["src"]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})